import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";

const generatePDF = (data) => {
  var doc = new jsPDF("l", "mm", "a4");
  var d = format(new Date(), "yyyy-MM-dd");
  doc.text("Customer List " + d, 14, 15);

  doc.autoTable({
    startY: 20,
    columns: [
      { header: "Email", dataKey: "email" },
      { header: "First Name", dataKey: "firstName" },
      { header: "Last Name", dataKey: "lastName" },
      { header: "Phone Number", dataKey: "phoneNumber" },
      { header: "Total Requests", dataKey: "requestCount" },
    ],
    body: data || [],
    theme: "grid",
  });

  doc.save(`customer_report_${d}.pdf`);
};

export default generatePDF;
